import { postClientVerify } from '../services/api/requests/SSO.js'
// import { getSSOData } from '../services/data/sso.js'
// import { doRequestSSOCode, doVerifyToken } from './Login.js'

export const doVerifyClient = async ({
  credentials,
  setLoading,
  setErrorMessage,
  redirectIfLoggedIn,
}) => {
  try {
    const response = await postClientVerify(credentials)

    if (response.status === 401) {
      throw new Error('Unauthorized')
    }

    if (response.status === 200 && credentials.redirectUri) {
      await redirectIfLoggedIn(credentials)
    }
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = error.message || 'Network Error' } = data || {}

    if (status === 401) {
      setLoading(false)
      setErrorMessage('Unauthorized')
      return
    }

    setLoading(false)
    setErrorMessage(message)
  }
}

export const doOpenSureSeats = async () => {
  let redirectLink = process.env.REACT_APP_SURESEATS_LINK

  window.open(redirectLink, '_blank', 'noopener,noreferrer')
}
